import { Component, Input, OnInit, signal } from '@angular/core';
import { CustomInfluenzaService } from '../custom-influenza.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Voucher } from '@spartacus/cart/base/root';

@Component({
  selector: 'app-pharmacy-association',
  templateUrl: './pharmacy-association.component.html',
  styleUrls: ['./pharmacy-association.component.scss'],
})
export class PharmacyAssociationComponent implements OnInit {
  constructor(protected influenzaService: CustomInfluenzaService) {}
  @Input() appliedVouchers: Voucher[];

  ngOnInit(): void {
    if (this.appliedVouchers) {
      this.form.patchValue({
        pharmacyAssociation: this.appliedVouchers?.[0]?.code || '',
      });
      this.form.disable();
    } else {
      this.influenzaService.getPharmacyAssociation().subscribe((data) => {
        if (data[0]?.code) {
          this.form.patchValue({
            pharmacyAssociation: data[0]?.code || '',
          });
          this.form.disable();
        }
      });
    }
  }

  submitResult = signal<{
    success?: boolean;
  }>(null);

  form = new FormGroup({
    pharmacyAssociation: new FormControl('', Validators.required),
  });

  clearStatus() {
    this.submitResult.set(null);
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.influenzaService
        .setPharmacyAssociation(this.form.value.pharmacyAssociation)
        .subscribe({
          next: () => {
            this.submitResult.set({
              success: true,
            });
            this.form.disable();
          },
          error: () => {
            this.submitResult.set({
              success: false,
            });
          },
        });
    }
  }
}
